import { z } from 'zod';

const suggestionsSchema = z.array(
  z.object({
    leftText: z.string().optional(),
    rightText: z.string(),
    url: z.string(),
    searchRequest: z.object({
      sections: z.array(z.string()),
      terms: z.string().optional(),
      makeModelFilters: z
        .array(
          z.object({
            make: z.string(),
            model: z.string().optional(),
          }),
        )
        .optional(),
      filters: z
        .array(
          z.object({
            name: z.string(),
            values: z.array(z.string()),
          }),
        )
        .optional(),
    }),
  }),
);

export type Suggestion = z.infer<typeof suggestionsSchema>[number];

export const getAutoCompleteResponseSchema = z.object({
  searchTerm: z.string(),
  suggestions: suggestionsSchema,
});

export type GetAutoCompleteResponse = z.infer<
  typeof getAutoCompleteResponseSchema
>;
